import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d1b1861a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b1861a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1b1861a')) {
      api.createRecord('d1b1861a', component.options)
    } else {
      api.reload('d1b1861a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d1b1861a&scoped=true", function () {
      api.rerender('d1b1861a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/imageSeeDialog/index.vue"
export default component.exports